import { useMemo } from 'react'

export type SIZE = 'sm' | 'md'

export const useSize = (size: SIZE) => {
  return useMemo(() => {
    switch (size) {
      case 'sm':
        return {
          viewBox: '-11 -11 22 22',
          r: '10',
          strokeWidth: '2.5',
          width: '18px',
        }
      case 'md':
        return {
          viewBox: '-24 -24 48 48',
          r: '20',
          strokeWidth: '4',
          width: '48px',
        }
      default:
        return {
          viewBox: '-24 -24 48 48',
          r: '20',
          strokeWidth: '4',
          width: '48px',
        }
    }
  }, [size])
}
